<template>
	<div>
		<div class="navigationBg" :style="index == 0 ? '':'position:static;background-color:rgba(0,0,0,.66);'">
			<header class="navigation">
				<h1>
					<img class="logo" alt="筑橙科技" src="../resource/images/logo.svg">
				</h1>
				<nav class="navigator">
					<div @click="navigation('/',0)" :class="index == 0 ? 'navigatorText acitve' : 'navigatorText'">
						首页
						<div :class="index == 0 ? 'block activeBlock' : 'block' "></div>
					</div>
					<!-- <div @click="reminder()" class="navigatorText">产品中心
						<div class="block"></div>
					</div> -->
					<div @click="navigation('/exampleList',1)"
						:class="index == 1 ? 'navigatorText acitve' : 'navigatorText'">应用案例
						<div :class="index == 1 ? 'block activeBlock' : 'block' "></div>
					</div>
					<div @click="navigation('/newsList',2)"
						:class="index == 2 ? 'navigatorText acitve' : 'navigatorText'">筑橙新闻
						<div :class="index == 2 ? 'block activeBlock' : 'block' "></div>
					</div>
					<div @click="navigation('/aboutUs',3)"
						:class="index == 3 ? 'navigatorText acitve' : 'navigatorText'">关于我们
						<div :class="index == 3 ? 'block activeBlock' : 'block' "></div>
					</div>
					<div @click="open()" class="navigatorText">在线联系
						<div class="block"></div>
					</div>
				</nav>
			</header>
		</div>
	</div>

</template>

<script>
	export default {
		props: {
			'index': {
				type: Number,
				value: 0
			}
		},
		name: 'navigator',
		data() {
			return {
				// index: 0
			}
		},
		methods: {
			navigation(url, index) {


				// console.log(url, index, this.$route, this.index)
				if (url == this.$route.path) {
					// 是在当前链接上点的跳转

				} else {

					// this.index = index
					this.$router.push({
						path: url
					})
				}
			},
			open() {
				window.open("http://qingflow.com/f/a445638c?qfchannel=Website")
			}
		},
		mounted() {
			console.log("this.index:", this.index);
		}
	}
</script>


<style scoped>
	.logo {
		width: 154px;
		height: 38px;
	}

	.navigation {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navigator {
		display: flex;
		align-items: center;
	}

	.navigatorText {
		line-height: 25px;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #fff;
		margin-left: 60px;
		cursor: pointer;
		transition: all .3s;
		position: relative;
	}

	.navigatorText:nth-child(1) {
		margin-left: 0px;
	}

	.navigatorText:hover {
		color: #EA5B24;
	}

	.block {
		position: absolute;
		/* width: 33px; */
		width: 100%;
		height: 2px;
		background-color: #fff;
		transition: all .3s;
		left: 0;
		bottom: -5px;
		opacity: 0;
	}

	.navigatorText:hover .block {
		background-color: #EA5B24;
		opacity: 1;
	}

	.navigationBg {
		width: 100%;
		background-color: rgba(0, 0, 0, 0.15);
		display: flex;
		justify-content: center;
		position: absolute;
		left: 0;
		top: 0;
	}

	.navigatorText {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/navigator.vue